<template>
  <el-input
    ref="inputRef"
    class="p-input"
    v-bind="$attrs"
    :type="type"
    :size="size"
    :placeholder="placeholder"
    :maxlength="maxlength"
    :disabled="disabled"
    :autosize="autosize"
    :rows="rows"
    :readonly="readonly"
    :name="name"
    :autofocus="autofocus"
    :autocomplete="autocomplete"
    :clearable="clearable"
    :show-word-limit="showWordLimit"
    :show-password="password"
    :prefix-icon="prefix"
    :suffix-icon="suffix"
    v-on="$listeners"
    v-model="innerValue"
  >
  </el-input>
</template>

<script>
export default {
  name: 'CustomizeFormInput',
  props: {
    type: String,
    value: [String, Number],
    size: String,
    placeholder: String,
    maxlength: Number,
    disabled: Boolean,
    autosize: [Boolean, Object],
    rows: Number,
    readonly: Boolean,
    name: String,
    autofocus: Boolean,
    autocomplete: String,
    clearable: Boolean,
    showWordLimit: Boolean,
    password: Boolean,
    prefix: String,
    suffix: String,
  },

  data() {
    return {
      innerValue: '',
    };
  },

  watch: {
    value: {
      immediate: true,
      handler(val, prevVal) {
        if (val !== prevVal) {
          this.innerValue = val;
        }
      },
    },
    innerValue(val, prevVal) {
      if (val !== prevVal) {
        this.$emit('input', val);
      }
    },
  },

  methods: {
    focus() {
      this.$refs.inputRef.focus();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
